export function addNumberPostfix(num: number): string {
    const suffixes = new Intl.PluralRules("en", { type: "ordinal" })
    const suffix = {
        one: "st",
        two: "nd",
        few: "rd",
        other: "th"
    }[suffixes.select(num)]
    return num + suffix
}
